import React from "react";
import { Box } from "@material-ui/core";
import RequestActions from "./RequestActions";
import TextFieldRender from 'components/TextFieldRender/TextFieldRender';
import CatalogSelector from "components/CatalogSelector/CatalogSelector";
import useRequestForm from "hooks/useRequestForm";
import useRequestValidation from "hooks/useRequestValidation";

export default function OldSupersededForm({ initialValues = {}, onSuccess = () => { } }) {
    const { submitRequest, onApprove, onDecline, onMarkAsOpen } = useRequestForm(onSuccess);
    const formik = useRequestValidation('old-superseded', submitRequest, initialValues);

    const handleCatalogChange = (e) => formik.setFieldValue("catalogId", e.target.value);

    return (
        <form onSubmit={formik.handleSubmit}>
            <Box>
                <Box my={2}>
                    <CatalogSelector
                        value={formik.values.catalogId}
                        onChange={handleCatalogChange}
                        error={formik.touched.catalogId && Boolean(formik.errors.catalogId)}
                    />
                </Box>
                <Box mb={2}>
                    <TextFieldRender
                        fullWidth
                        label="Current Part#:"
                        variant="outlined"
                        size="small"
                        value={formik.values.partNumber}
                        handleBlur={(value) => formik.setFieldValue("partNumber", value)}
                        error={formik.touched.partNumber && Boolean(formik.errors.partNumber)}
                    />
                </Box>
                <Box mb={2}>
                    <TextFieldRender
                        fullWidth
                        label="New Part#:"
                        variant="outlined"
                        size="small"
                        value={formik.values.newPartNumber}
                        handleBlur={(value) => formik.setFieldValue("newPartNumber", value)}
                        error={formik.touched.newPartNumber && Boolean(formik.errors.newPartNumber)}
                    />
                </Box>
                <Box mb={2}>
                    <TextFieldRender
                        fullWidth
                        label="Comment:"
                        multiline
                        rows={4}
                        variant="outlined"
                        value={formik.values.comment}
                        handleBlur={(value) => formik.setFieldValue("comment", value)}
                        error={formik.touched.comment && Boolean(formik.errors.comment)}
                    />
                </Box>
                <RequestActions
                    initialValues={initialValues}
                    formik={formik}
                    onApprove={onApprove}
                    onDecline={onDecline}
                    onMarkAsOpen={onMarkAsOpen}
                />
            </Box>
        </form>
    )
}
